/**
 * AAA IDP confirm email reducer
 * 
 */
import { DELETE, CONFIRM_EMAIL, EMAIL, VALIDATE } from '../../actions/types';
const initialState = {
  error: false,
  required: true,
  valid: null,
  value: '',
  emailValue: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case EMAIL:
      {
        const emailValue = action.value;
        const {
          value
        } = state;
        if (value === '') {
          return {
            ...state,
            emailValue
          };
        }
        const valid = value !== '' && value === emailValue;
        return {
          ...state,
          error: !valid,
          valid,
          emailValue
        };
      }
    case CONFIRM_EMAIL:
      {
        const {
          value
        } = action;
        const {
          emailValue
        } = state;
        const valid = value !== '' && value === emailValue;
        return {
          ...state,
          error: !valid,
          valid,
          value
        };
      }
    case VALIDATE:
      {
        const {
          value,
          emailValue
        } = state;
        const valid = value !== '' && value === emailValue;
        return {
          ...state,
          error: !valid,
          valid
        };
      }
    default:
      return state;
  }
}